import { render, staticRenderFns } from "./tabs-search-query.vue?vue&type=template&id=328b3374"
import script from "./tabs-search-query.vue?vue&type=script&lang=js"
export * from "./tabs-search-query.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports